import BreadCrumbs from './breadcrumbs';

export default BreadCrumbs;
